export default __webpack_public_path__ + "static/sticky_notes-3fbd19557a5a46ce83efee1cfc79f565.jpg";